function DomainIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      className="min-w-[19px]"
    >
      <path
        d="M9.50517 9.9358C10.604 9.9358 11.4948 9.045 11.4948 7.94613C11.4948 6.84727 10.604 5.95646 9.50517 5.95646C8.40631 5.95646 7.5155 6.84727 7.5155 7.94613C7.5155 9.045 8.40631 9.9358 9.50517 9.9358Z"
        stroke="currentColor"
        strokeWidth="1.499"
        strokeMiterlimit="10"
      />
      <path
        d="M14.7234 7.96886C14.7234 12.2364 10.2258 15.6866 9.50517 15.6866C8.78454 15.6866 4.2879 12.2214 4.2879 7.96886C4.2879 6.58542 4.83763 5.25864 5.81615 4.28039C6.79467 3.30215 8.12183 2.75259 9.50567 2.75259C10.8895 2.75259 12.2167 3.30215 13.1952 4.28039C14.1737 5.25864 14.7234 6.58542 14.7234 7.96886Z"
        stroke="currentColor"
        strokeWidth="1.499"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export default DomainIcon;
